import React from 'react';
import { FormikProps } from 'formik';
import TextField from '@material-ui/core/TextField';
import { InputLabelProps as MuiInputLabel } from '@material-ui/core/InputLabel';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import { disabledBackground, lightGrey } from '../../../app/theme';

const useStyles = makeStyles(() => ({
  disabled: {
    '& > div': {
      '& > fieldset': {
        borderColor: `${lightGrey} !important`,
      },
      '& > input': {
        borderRadius: 4,
        backgroundColor: disabledBackground,
      },
    },
  },
}));

interface TextFieldWrapperProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: FormikProps<any>;
  formKey: string;
  label?: string;
  variant?: 'standard' | 'outlined' | 'filled' | undefined;
  type?: string;
  multiline?: boolean;
  inputLabelProps?: MuiInputLabel;
  hideError?: boolean;
  hideHelperText?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  autocomplete?: string;
  select?: boolean;
}

const TextFieldWrapper = ({
  form,
  formKey,
  label,
  variant,
  type,
  multiline,
  inputLabelProps,
  hideError,
  hideHelperText,
  disabled,
  select,
  autocomplete,
  children,
}: TextFieldWrapperProps): JSX.Element => {
  const classes = useStyles();
  return (
    <TextField
      className={classNames('form-control', disabled ? classes.disabled : '')}
      label={label}
      id={formKey}
      type={type}
      multiline={multiline}
      variant={variant}
      disabled={disabled}
      select={select}
      InputLabelProps={inputLabelProps}
      error={!hideError && form.touched[formKey] && !!form.errors[formKey]}
      helperText={!hideHelperText && form.touched[formKey] && !!form.errors[formKey] ? form.errors[formKey] : ' '}
      autoComplete={autocomplete}
      {...form.getFieldProps(formKey)}
      onBlur={form.handleBlur}
    >
      {children}
    </TextField>
  );
};

export default TextFieldWrapper;
